/**
 * Gets a React component's display name, given an ElementType (i.e., a
 * function, class, or string). If unable to determine, returns "(unknown)".
 *
 * The returned name is suitable for display purposes and messaging only, and
 * should not be used for identity purposes.
 *
 * @param componentType The React component whose name to get.
 * @returns A display name for the component.
 */
export function getComponentName(componentType: React.ElementType | string) {
  if (typeof componentType === 'string') {
    return componentType;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return componentType.displayName || (componentType as any).name || '(unknown)';
}
